enum KioskConnectionMode {
  Cookie = 1,
  URL = 2,
}

export default KioskConnectionMode;
